export default "__VITE_ASSET__BG2oQLz3__"